export const Actions = {
    PopUp: 1,
    RedirectTo: 2,
    ExecuteSP: 3,
    Randomize: 4
};